import React from 'react';
import {
    UseFormRegister,
    FormState
} from "react-hook-form";
import type {
    ItemGroupInputs,
} from '../model/item-group.types';


interface ItemGroupBasicFieldsProps {
    auth: any;
    register: UseFormRegister<ItemGroupInputs>;
    errors: FormState<ItemGroupInputs>["errors"];
}

const ItemGroupBasicFields: React.FC<ItemGroupBasicFieldsProps> = ({
    register,
    errors,
}) => {

    return (<>
        <div className="row">
            <div className="col">
                <ul className="list-unstyled">
                    <li className="mb-3">
                        <label htmlFor="id_name" className="form-label">그룹명</label>
                        <input
                            type="text"
                            id="id_name"
                            className={`form-control ${errors.name ? "is-invalid" : ""}`}
                            {...register("name", {
                                required: "그룹명을 입력하세요.",
                                minLength: { value: 2, message: "2자 이상 입력하세요." },
                                maxLength: { value: 100, message: "100자 이하로 입력하세요." }
                            })}
                        />
                        {errors.name && <div className="invalid-feedback">{errors.name.message}</div>}
                    </li>
                    <li className="mb-3">
                        <label htmlFor="id_description" className="form-label">그룹메모</label>
                        <input
                            type="text"
                            id="id_description"
                            className={`form-control ${errors.description ? "is-invalid" : ""}`}
                            {...register("description", {
                                minLength: { value: 2, message: "2자 이상 입력하세요." }
                            })}
                        />
                        {errors.description && <div className="invalid-feedback">{errors.description.message}</div>}
                    </li>
                    <li className="mb-3">
                        <label htmlFor="id_sort_order" className="form-label">우선순위</label>
                        <input
                            type="text"
                            id="id_sort_order"
                            className={`form-control ${errors.sort_order ? "is-invalid" : ""}`}
                            {...register("sort_order", {
                                required: "우선순위를 입력하세요.",
                                pattern: {
                                    value: /^[0-9]+$/,
                                    message: "숫자만 입력하세요."
                                }
                            })}
                        />
                        <div className="form-text" id="basic-addon4">우선순위가 높을수록 위에 배치, 같은 순위 시 생성일시 순</div>
                        {errors.sort_order && <div className="invalid-feedback">{errors.sort_order.message}</div>}
                    </li>
                </ul>
            </div>
        </div>
    </>);
};

export default ItemGroupBasicFields;
